import { ApprovalType, DefectType } from '../utils/enums';
import { Company } from './company';
import { OrderFile } from './order-file';
import { OrderLayout } from './order-layout';
import { Service } from './service';
import { Team } from './team';
import { OrderWithdrawal } from './order-withdrawal';

export enum OrderStatus {
  VIRTUAL = 'virtual',
  VIRTUAL_REPROVED = 'virtual_reproved',
  CREATED = 'created',
  WAITING_MATERIAL = 'waiting_material',
  MATERIAL_RECEIVED = 'material_received',
  RELEASED_PRODUCTION = 'released_production',
  ON_PRODUCTION = 'on_production',
  PRODUCED = 'produced',
  WAITING_PACKAGING = 'waiting_packaging',
  FINISHED = 'finished',
  DISPATCHED = 'dispatched',
  CANCELLED = 'cancelled',
  CHANGE_MATERIAL = 'waiting_material_change',
  LOWER_QTDE = 'lower_quantity',
  PAUSED = 'paused',
  LAYOUT_PENDING = 'layout_pending',
  LAYOUT_APPROVAL = 'layout_approval',
}

export enum FinancialStatus {
  PENDING = 'pending',
  INVOICED = 'invoiced',
  INITIAL = 'initial',
}

export enum OrderPaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  NOT_PAID = 'not_paid',
  REVIEWED = 'reviewed',
  PARTIAL = 'partial',
}

export enum OrderProblem {
  INCORRECT_QUANTITY = 'incorrect_quantity',
  PRODUCT_DEFECT = 'product_defect',
}

export enum OrderFirstPieceStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REPROVED = 'reproved',
}

export enum OrderType {
  EVENT = 'event',
  REWORK = 'rework',
  REPETITION = 'repetition',
  SAMPLE = 'sample',
  ORDER = 'order',
}

export enum MaterialType {
  SHEET = 'sheet',
  ACRYLIC = 'acrylic',
  HANDLING = 'handling',
  FREIGHT = 'freight',
  OTHER = 'other',
  NON_MATERIAL = 'non_material',
}

export enum FinancialOrderApproval {
  APPROVED = 'approved',
  REPROVED = 'reproved',
  PENDING_REVIEW = 'pending_review',
}

export type Order = {
  id: number;
  service: Service;
  eventService?: Service;
  company: Company;
  team: Team;
  os: string;
  internalNumber: string;
  status: OrderStatus;
  type: OrderType;
  product: string;
  productMaterial: string;
  productColor: string;
  engravingText: string;
  quantity: number;
  quantityVolume?: number;
  note?: string;
  fileLink?: string;
  price?: string;
  samplePrice?: string;
  clichePrice?: string;
  pholitoPrice?: string;
  manipulationPrice?: string;
  vectorizationPrice?: string;
  hasDefect: DefectType;
  defectAmount?: number;
  carrierName?: string;
  needsPickUp?: boolean;
  needsPostal?: boolean;
  pickUpNumber?: string;
  pickUpLocation?: string;
  pickUpName?: string;
  createdAt: string;
  updatedAt: string;
  pickUpedAt?: string;
  pickUpForecast?: string;
  finishedAt?: string;
  finishForecast?: string;
  finishVendorForecast?: string;
  receiptedAt?: string;
  receiptForecast?: string;
  dispatchedAt?: string;
  dispatchForecast?: string;
  dispatchLocation?: string;
  deletedAt?: string;
  issueDate?: string;
  files: OrderFile[];
  layout: OrderLayout | null;
  financialStatus?: FinancialStatus;
  financialNote?: string;
  paymentType?: string;
  job?: string;
  supplier?: string;
  productCodeSupplier?: string;
  rework?: boolean;
  reworkUser?: string;
  reworkOriginOrder?: Order;
  isSample?: boolean;
  dispatchName: string;
  approvalBy?: string;
  approval?: boolean;
  approvalType?: ApprovalType;
  approvalOn?: string;
  changeColorPrice?: string;
  changeColorTotalPrice?: string;
  origin: Order;
  requestAssociation: boolean;
  colorChangeAmount?: number;
  discountPrice?: string;
  originalPrice?: string;
  nightApproval?: boolean;
  nightApprovalAt?: string;
  desiredDeadline?: Date;
  urgencyFee?: string;
  urgencyFeeApprovalAt?: Date;
  deadlineNote?: string;
  postalPrice?: number;
  materialType: MaterialType;
  serviceRating?: number;
  vendorRating?: number;
  ratingNote?: string;
  ratingDate?: Date;
  financialApproval?: FinancialOrderApproval;
  finishProductionForecast?: string;
  withdrawalType?: string;
  kitCode?: string;
  isCancelledVirtualLayout?: boolean;
  priceChecked?: boolean;
  withdrawalOrders?: { withdrawal: OrderWithdrawal }[];
};

export type OrderToSelect = {
  id: number;
  os: string;
  status: OrderStatus;
  financialStatus: string;
  company: string;
  team: string;
  teamId: number;
  product: string;
  productMaterial: string;
  productColor: string;
  createdAt: string;
  quantity: number;
  price: string;
  totalPrice: string;
};

export type OrderBasicInfo = {
  id: number;
  os: string;
  product: string;
  productMaterial: string;
  productColor: string;
  quantity: number;
  status: OrderStatus;
  serviceName: string;
  note: string;
  finishVendorForecast: Date;
  deadlineNote: string;
  desiredDeadline: Date;
  internalNumber: string;
  quantityVolume: number;
};

export type OrderRateInfo = {
  serviceRating: number;
  vendorRating: number;
  ratingNote?: string;
  ratingDate: Date;
};
